"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Elevated = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Elevated = function Elevated(_ref) {
  var customFontWoff = _ref.customFontWoff,
      customFontWoff2 = _ref.customFontWoff2;
  console.log('CF', customFontWoff, customFontWoff2);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("h1", null, "elevated!"));
};

exports.Elevated = Elevated;